/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { Button } from "@mui/material";
import { ImageEditContext } from "cms/images/image-selector/context/image-edit-context";
import { MODES } from "cms/images/image-selector/image-selector-config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ImageDialogBottomActions = () => {
    const imageEditContext = useContext(ImageEditContext);
    const selectedImage = imageEditContext?.selectedImage;
    const onSelectImage = imageEditContext?.onSelectImage;
    const onSaveImage = imageEditContext?.onSaveImage;
    const setMode = imageEditContext?.setMode;
    const hasChanges = imageEditContext?.hasChanges;
    const setHasChanges = imageEditContext?.setHasChanges;
    const isFieldValid = imageEditContext?.isFieldValid;
    const disabled = !hasChanges || !isFieldValid;

    const handleSave = () => {
        onSaveImage();
        onSelectImage(selectedImage);
        setMode(MODES.SELECT);
        setHasChanges(false);
    };
    
    return (
        <div className="simplicity-image-selector-window-footer">
            <Button
                variant="contained"
                color="primary"
                onClick={handleSave}
                disabled={disabled}
                startIcon={<FontAwesomeIcon icon="fa-regular fa-check" />}
            >
                {disabled ? "Unchanged" : "Save changes"}
            </Button>
        </div>
    );
};

export { ImageDialogBottomActions };
